import { useMemo, useCallback } from 'react';
import { UISortableList } from 'ui-addon-draggable-compat';
import { jsx as _jsx } from "react/jsx-runtime";
const CrmCardsDragList = ({
  dragGroupId,
  orderedItems,
  onOrderChange
}) => {
  const handleOrderChange = useCallback(newOrder => {
    onOrderChange(newOrder.map(item => item.id));
  }, [onOrderChange]);
  const items = useMemo(() => orderedItems.map(item => Object.assign({
    accept: dragGroupId
  }, item)), [orderedItems, dragGroupId]);
  return /*#__PURE__*/_jsx(UISortableList, {
    items: items,
    onOrderChange: handleOrderChange
  });
};
export default CrmCardsDragList;